module.exports = __webpack_public_path__ + "fonts/baronsans-mediumitalic-webfont.69a0551d.woff2";